import React from 'react';
import { MultiStepModal } from '@components/common/multiStepModal';

import { AccountTypePickerModalStep } from './steps/accountTypePickerModalStep';
import { AccountTypeFormModalStep } from './steps/accountTypeFormModalStep';
import { useDesignVariant } from '../designVariantContext';
import { useAccountManagementStore } from '../store';

interface CreateAccountModalProps {
  open: boolean;
  onClose: () => void;
}

export const CreateAccountModal: React.FC<CreateAccountModalProps> = ({ open, onClose }) => {
  const variant = useDesignVariant();
  const { adapter } = useAccountManagementStore();

  // A resource may replace the create flow wholesale (data-retention supplies a
  // provider picker -> config form pair); every other resource type keeps the
  // account-type-picker -> form flow.
  const steps = adapter?.getCreateStepTree?.() ?? [
    {
      key: 'accountTypePicker',
      title: 'Create account to connect',
      component: () => <AccountTypePickerModalStep />,
    },
    {
      key: 'accountTypeForm',
      title: 'Configure account',
      component: () => <AccountTypeFormModalStep />,
    },
  ];

  return (
    <MultiStepModal
      showCross
      variant={variant}
      steps={steps}
      open={open}
      onClose={onClose}
      breadcrumb={{ hide: true }}
      size="lg"
    />
  );
};
